import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function SearchBox() {
  const [query, setQuery] = useState("");

  const results = useMemo(() => {
    const q = query.trim();
    if (!q) return [];
    return topics
      .filter(
        (topic) =>
          topic.title.includes(q) ||
          topic.categoryName.includes(q) ||
          topic.tags.some((tag) => tag.includes(q)),
      )
      .slice(0, 5);
  }, [query]);

  return (
    <div className="relative w-full max-w-xl">
      <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2.5">
        <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
          <i className="ri-search-line text-lg" />
        </span>
        <input
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="搜话题、搜标签，比如「大结局」「音乐节」"
          aria-label="搜索话题"
          className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
        />
        {query && (
          <button
            type="button"
            aria-label="清空搜索"
            onClick={() => setQuery("")}
            className="flex h-5 w-5 cursor-pointer items-center justify-center text-foreground-400 transition-colors hover:text-foreground-700"
          >
            <i className="ri-close-circle-fill text-base" />
          </button>
        )}
      </div>

      {query.trim() && (
        <div className="absolute left-0 right-0 top-[calc(100%+8px)] z-30 overflow-hidden rounded-xl border border-background-200 bg-background-50">
          {results.length > 0 ? (
            <ul className="divide-y divide-background-100">
              {results.map((topic) => (
                <li key={topic.id}>
                  <Link
                    to={`/topic/${topic.id}`}
                    onClick={() => setQuery("")}
                    className="flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100"
                  >
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className="ri-chat-smile-2-line text-base" />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-medium text-foreground-900">
                        {topic.title}
                      </span>
                      <span className="mt-0.5 block text-xs text-foreground-500">
                        {topic.categoryName} · {topic.comments} 条讨论
                      </span>
                    </span>
                    <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                      <i className="ri-arrow-right-s-line text-base" />
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <div className="flex items-center gap-2 px-4 py-4 text-sm text-foreground-500">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-emotion-sad-line text-base" />
              </span>
              暂时没找到相关话题，换个词试试看
            </div>
          )}
        </div>
      )}
    </div>
  );
}